module.exports = __webpack_public_path__ + "img/Andaluza-25-min.c3ff6ccd.jpg";